/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'guide-graphics/dialog-shape': {
    width: 16,
    height: 16,
    viewBox: '0 0 23 43.5',
    data: '<g data-name="Layer 2"><path pid="0" d="M0 0v43.5L21 15l2-5.5z" _fill="#fff" data-name="Layer 1"/></g>'
  }
})
